class QuickBuyProductForm extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.isPopupOpen = false
    this.productData = null
    this.productImages = []
    this.currentImageIndex = 0
    this.hoverDisabled = false
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.initialized) return

    const productCard = this.closest('.product-card-wrapper')
    if (!productCard) return

    this.productCard = productCard

    // Parse product images from JSON attribute
    this.parseProductImages()

    this.productHandle = this.getAttribute('data-product-handle')
    this.productId = this.getAttribute('data-product-id')

    // HTML is already rendered in Liquid, just setup navigation
    this.createNavigationHTML()
    this.initialized = true
  }

  setupListeners () {
    super.setupListeners()

    this.handleTriggerClick = this.handleTriggerClick.bind(this)
    this.handleCloseClick = this.handleCloseClick.bind(this)
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    this.handleNavigationClick = this.handleNavigationClick.bind(this)
    this.onPushCartBeforeAdd = this.onPushCartBeforeAdd.bind(this)
    this.handleVariantChange = this.handleVariantChange.bind(this)

    // Listeners for modal controls
    const trigger = this.querySelector('[data-quick-buy-trigger]')
    const closeBtn = this.querySelector('[data-quick-buy-close]')

    if (trigger) this.listeners.add(trigger, 'click', this.handleTriggerClick)
    if (closeBtn) this.listeners.add(closeBtn, 'click', this.handleCloseClick)

    // Listen for variant radio changes to update aria-checked
    const variantInputs = this.querySelectorAll('.qck-AddButton_VariantInput')
    variantInputs.forEach(input => {
      this.listeners.add(input, 'change', this.handleVariantChange)
    })

    // Close popup when cart add starts
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.BEFORE_ADD_FROM_FORM,
      this.onPushCartBeforeAdd,
    )
  }

  handleVariantChange (event) {
    // Update aria-checked on all labels
    const labels = this.querySelectorAll('.qck-AddButton_VariantOption')
    labels.forEach(label => {
      const input = label.querySelector('input[type="radio"]')
      label.setAttribute('aria-checked', input.checked ? 'true' : 'false')
    })
  }

  parseProductImages () {
    try {
      const productImagesAttr = this.getAttribute('data-product-images')
      if (productImagesAttr) {
        const imagesData = JSON.parse(productImagesAttr)
        // Convert Shopify image objects to URLs array
        this.productImages = imagesData.map(img => img.src || img)
      } else {
        this.productImages = []
      }
    } catch (error) {
      console.warn('Error parsing product images:', error)
      this.productImages = []
    }
  }

  handleTriggerClick (event) {
    event.preventDefault()
    event.stopPropagation()

    // Close other popups
    document.querySelectorAll('.qck-AddButton_Popup.popup-visible').forEach(popup => {
      if (popup !== this.popup) {
        popup.classList.remove('popup-visible')
      }
    })

    if (this.isPopupOpen) {
      this.closePopup()
    } else {
      this.openPopup()
    }
  }

  handleCloseClick (event) {
    event.preventDefault()
    event.stopPropagation()
    this.closePopup()
  }

  openPopup () {
    if (!this.popup) return

    this.popup.style.display = 'block'
    this.isPopupOpen = true
    this.productCard.classList.add('quick-add-popup-open')

    requestAnimationFrame(() => {
      this.popup.classList.add('popup-visible')
    })

    this.attachOutsideClickListener()
  }

  closePopup () {
    if (!this.popup) return

    this.popup.classList.remove('popup-visible')

    setTimeout(() => {
      this.popup.style.display = 'none'
      this.isPopupOpen = false
      this.productCard.classList.remove('quick-add-popup-open')
      this.removeOutsideClickListener()
    }, 200)
  }

  onPushCartBeforeAdd (event) {
    // Check if this form triggered the add
    const form = event.detail?.form
    if (form && this.contains(form)) {
      this.closePopup()
    }
  }

  attachOutsideClickListener () {
    document.addEventListener('click', this.handleOutsideClick)
  }

  removeOutsideClickListener () {
    document.removeEventListener('click', this.handleOutsideClick)
  }

  handleOutsideClick (event) {
    if (!this.contains(event.target)) {
      this.closePopup()
    }
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.removeOutsideClickListener()

    // Clean up navigation button event listeners
    const navButtons = this.productCard?.querySelectorAll('.product-nav-btn')
    navButtons?.forEach(btn => btn.removeEventListener('click', this.handleNavigationClick))

    window.BAO.eventBus.removeEventListener(
      window.BAO.EVENTS.PUSH_CART.BEFORE_ADD_FROM_FORM,
      this.onPushCartBeforeAdd,
    )
  }

  createNavigationHTML () {
    // Only show navigation if there are multiple images
    if (this.productImages.length <= 1) {
      return
    }

    const navContainer = document.createElement('div')
    navContainer.className = 'product-image-navigation'
    navContainer.innerHTML = `
      <button class="product-nav-btn product-nav-btn--prev" aria-label="Previous image">
        <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.9751 21L0.975098 11L10.9751 1" stroke="#121212" stroke-linecap="round"/>
        </svg>
      </button>
      <button class="product-nav-btn product-nav-btn--next" aria-label="Next image">
        <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.975098 1L10.9751 11L0.975098 21" stroke="#121212" stroke-linecap="round"/>
        </svg>
      </button>
    `

    this.productCard.appendChild(navContainer)

    // Add event listeners to navigation buttons
    const navButtons = this.productCard.querySelectorAll('.product-nav-btn')
    navButtons.forEach(btn => btn.addEventListener('click', this.handleNavigationClick))

    const swiperContainer = this.productCard.querySelector('.card__inner')

    // Only add touch listeners for devices under 750px
    if (window.innerWidth < 750 && swiperContainer) {
      // Bind touch event handlers to maintain proper context
      this.handleTouchStart = this.handleTouchStart.bind(this)
      this.handleTouchMove = this.handleTouchMove.bind(this)
      this.handleTouchEnd = this.handleTouchEnd.bind(this)

      swiperContainer.addEventListener('touchstart', this.handleTouchStart)
      swiperContainer.addEventListener('touchmove', this.handleTouchMove)
      swiperContainer.addEventListener('touchend', this.handleTouchEnd)
    }
  }

  handleTouchStart (e) {
    // Only enable swiper for devices under 750px
    if (window.innerWidth >= 750) return

    this.isTouching = true
    this.touchStartX = e.touches[0].clientX
    this.touchStartY = e.touches[0].clientY
    this.touchStartTime = Date.now()
  }

  handleTouchMove (e) {
    // Only enable swiper for devices under 750px
    if (window.innerWidth >= 750) return

    if (!this.isTouching) return

    const currentX = e.touches[0].clientX
    const currentY = e.touches[0].clientY
    const deltaX = currentX - this.touchStartX
    const deltaY = currentY - this.touchStartY

    // Check if this is more of a horizontal swipe than vertical (to avoid interfering with scroll)
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
      // Prevent default only for horizontal swipes to avoid scroll interference
      e.preventDefault()
      e.stopPropagation()
    }
  }

  handleTouchEnd (e) {
    // Only enable swiper for devices under 750px
    if (window.innerWidth >= 750) return

    if (!this.isTouching) return

    this.isTouching = false

    const touchEndX = e.changedTouches[0].clientX
    const touchEndY = e.changedTouches[0].clientY
    const deltaX = touchEndX - this.touchStartX
    const deltaY = touchEndY - this.touchStartY
    const touchDuration = Date.now() - this.touchStartTime

    // Check if this was a valid swipe (minimum distance and not too slow)
    const minSwipeDistance = 50
    const maxSwipeTime = 1000 // 1 second max

    // Ensure it's more horizontal than vertical
    if (Math.abs(deltaX) > Math.abs(deltaY) &&
        Math.abs(deltaX) > minSwipeDistance &&
        touchDuration < maxSwipeTime) {
      // Determine swipe direction
      const direction = deltaX > 0 ? 'prev' : 'next'

      // Reuse the existing navigation logic
      this.navigateImage(direction)
    }
  }

  navigateImage (direction) {
    // Calculate new index with circular navigation
    if (direction === 'prev') {
      this.currentImageIndex = this.currentImageIndex > 0
        ? this.currentImageIndex - 1
        : this.productImages.length - 1
    } else {
      this.currentImageIndex = this.currentImageIndex < this.productImages.length - 1
        ? this.currentImageIndex + 1
        : 0
    }

    // Update the product image
    this.updateProductImage()
  }

  handleNavigationClick (e) {
    e.preventDefault()
    e.stopPropagation()

    const direction = e.currentTarget.classList.contains('product-nav-btn--prev') ? 'prev' : 'next'

    // Reuse the navigation logic
    this.navigateImage(direction)
  }

  updateProductImage () {
    if (!this.productImages || this.productImages.length === 0) {
      return
    }

    const currentImageUrl = this.productImages[this.currentImageIndex]

    // Target the specific card media structure
    const cardMedia = this.productCard.querySelector('.card__media')
    const mediaContainer = cardMedia?.querySelector('.media')
    const mainImage = mediaContainer?.querySelector('img:first-child')

    if (mainImage && currentImageUrl) {
      // Generate the main image source with proper Shopify sizing
      const newSrc = currentImageUrl
      const newSrcset = this.generateShopifySrcset(currentImageUrl)

      // Update the image attributes
      mainImage.src = newSrc
      mainImage.srcset = newSrcset
      mainImage.alt = `Product image ${this.currentImageIndex + 1}`

      // Keep the existing sizes attribute for responsive behavior
      if (!mainImage.getAttribute('sizes')) {
        mainImage.setAttribute('sizes',
          '(min-width: 1200px) 267px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)',
        )
      }
    }
  }

  generateShopifySrcset (imageUrl) {
    const widths = [165, 360, 533, 720, 940, 1066]
    const srcsetParts = []

    // Get the base URL without size parameters
    const baseUrl = imageUrl.split('?')[0]
    const extension = baseUrl.split('.').pop()
    const urlWithoutExtension = baseUrl.replace(`.${extension}`, '')

    // Generate srcset for each width
    widths.forEach(width => {
      srcsetParts.push(`${urlWithoutExtension}_${width}x.${extension} ${width}w`)
    })

    // Add the original image as the largest size
    srcsetParts.push(`${baseUrl} 1200w`)

    return srcsetParts.join(', ')
  }

  get popup () {
    return this.querySelector('[data-quick-buy-popup]')
  }
}

// Define the custom element
customElements.define('quick-buy-product-form', QuickBuyProductForm)
